import { IdentityDto } from './../shared/identity.dto';
import { ContactDto } from './../shared/contact.dto';
import { BindingDto } from './binding.dto';
import { PropertyDto } from './property.dto';
import { HistoryDto } from './../shared/history.dto';
import { InheritanceDto } from './inheritance/inheritance.dto';

export class EntityDto {
  parent?: IdentityDto;
  picture?: string;
  type?: string;
  source?: string; // enum from api
  state?: string; // enum from api
  tags?: IdentityDto[] = [];
  bindings?: BindingDto[] = [];
  properties?: PropertyDto[] = [];
  contacts?: ContactDto[] = [];
  inheritance?: InheritanceDto;
  history?: HistoryDto;

  constructor(d?: EntityDto) {
    if (!d) {
      return;
    }
    this.parent = d.parent ? new IdentityDto(d.parent) : undefined;
    this.picture = d.picture;
    this.type = d.type;
    this.source = d.source;
    this.state = d.state;
    this.tags = d.tags ? d.tags.map(t => new IdentityDto(t)) : undefined;
    this.bindings = d.bindings
      ? d.bindings.map(b => new BindingDto(b))
      : undefined;
    this.properties = d.properties
      ? d.properties.map(p => new PropertyDto(p))
      : undefined;
    this.contacts = d.contacts
      ? d.contacts.map(c => new ContactDto(c))
      : undefined;
    this.history = d.history ? new HistoryDto(d.history) : undefined;
    this.inheritance = d.inheritance
      ? new InheritanceDto(d.inheritance)
      : undefined;
  }
}
